"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChipStatus;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../utils/constants");

var _excluded = ["label", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useChipStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: "10px",
      padding: "0px 8px"
    },
    label: {
      fontSize: "smaller"
    }
  };
});

var Chip = function Chip(_ref) {
  var label = _ref.label,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useChipStyle();
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "".concat(classes.root, " ").concat(className)
  }, props), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.label
  }, label));
};

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    valid: {
      // activeok
      backgroundColor: "#001f3f",
      color: "white"
    },
    ready: {
      backgroundColor: "#85144b",
      color: "white"
    },
    reactivated: {},
    revised: {
      backgroundColor: "#932ab6",
      color: "white"
    },
    approved: {
      backgroundColor: "#f39c12",
      color: "white"
    },
    "new": {
      backgroundColor: "#00a65a",
      color: "white"
    },
    invalid: {
      backgroundColor: "rgb(220, 0, 78)",
      color: "white"
    },
    active: {
      backgroundColor: "#0073b7",
      color: "white"
    },
    inactive: {
      backgroundColor: "#eaeaec",
      color: "white"
    },
    rejected: {
      backgroundColor: "#f39c12",
      color: "white"
    },
    deleted: {
      backgroundColor: "#cecece",
      color: "white"
    },
    duplicated: {
      backgroundColor: "#85144b",
      color: "white"
    }
  };
});

function ChipStatus(_ref2) {
  var code = _ref2.code,
      label = _ref2.label;
  var classes = useStyle();

  if (Number(code) === _constants.STATUS_ACTIVEOK) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "valid",
      className: classes.valid
    });
  }

  if (Number(code) === _constants.STATUS_READY) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "trivial",
      className: classes.ready
    });
  }

  if (Number(code) === _constants.STATUS_REACTIVATED) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "reactivated"
    });
  }

  if (Number(code) === _constants.STATUS_REVISED) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "revised",
      className: classes.revised
    });
  }

  if (Number(code) === _constants.STATUS_APPROVED) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "approved",
      className: classes.approved
    });
  }

  if (Number(code) === _constants.STATUS_NEW) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "new",
      className: classes["new"]
    });
  }

  if (Number(code) === _constants.STATUS_INVALID) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "invalid",
      className: classes.invalid
    });
  }

  if (Number(code) === _constants.STATUS_ACTIVE) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "active",
      className: classes.active
    });
  }

  if (Number(code) === _constants.STATUS_INACTIVE) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "inactive",
      className: classes.inactive
    });
  }

  if (Number(code) === _constants.STATUS_REJECTED) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "obselete",
      className: classes.rejected
    });
  }

  if (Number(code) === _constants.STATUS_DELETED) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "deleted",
      className: classes.deleted
    });
  }

  if (Number(code) === _constants.STATUS_BANNED) {
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: label || "duplikat",
      className: classes.duplicated
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Chip, {
    size: "small",
    label: label || code
  });
}

ChipStatus.propTypes = {
  /**
   * Kode status edaun
   */
  code: _propTypes["default"].oneOf([65, 16, 8, 4, 1, 2, -3, 64, 0, -1, -127, -126])
};